/**
 * login-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { MessageTag } from "../message-tag";

/**
 * The client sends a {@link LoginRequest} to communicate a
 * user's credentials to the server and attempt a log in.
 */
export class LoginRequest extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_LOGIN;
	public static tag : MessageTag = MessageTag.REQ_LOGIN;

  public expectsReply () : boolean
  {
    return true;
  }

  /**
   * Construct a new {@link AuthenticationRequestMessage}.
   *
   * @param login
   *        The user's login identifier
   * @param password
   *        The user's hashed password
   */
  constructor (public login : string, public password : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/login-request.ts